import { HIT_MIN_HEIGHT } from '@/config/constants'

export function getYTIdFromUrl(url) {
  url = /(youtube\.com\/(watch\?v=|v\/|embed\/)|youtu\.be\/)([\w-]+)/.exec(url)

  return url ? url[3] : false
}

export function getVimeoIdFromUrl(url) {
  url = /(player\.vimeo\.com\/video|vimeo\.com)\/(\d+)/.exec(url)

  return url ? url[2] : false
}

export function getDailymotionIdFromUrl(url) {
  url = /dailymotion\.com\/(embed\/)?video\/(\w+)/.exec(url)

  return url ? url[2] : false
}

export function getEmbedVideoUrl(url) {
  if (url.indexOf('youtube.com') > -1 || url.indexOf('youtu.be') > -1) {
    url = '//youtube.com/embed/' + getYTIdFromUrl(url)
  } else if (url.indexOf('vimeo.com') > -1) {
    url = '//player.vimeo.com/video/' + getVimeoIdFromUrl(url)
  } else if (url.indexOf('dailymotion.com') > -1) {
    url = '//dailymotion.com/embed/video/' + getDailymotionIdFromUrl(url)
  }

  return url || ''
}

export function getCodepenIdFromUrl(url) {
  url = /codepen\.(com|io)\/(\w+)\/(pen|embed)\/(\w+)/.exec(url)

  return url ? url[2] : false
}

export function getJsFiddleIdFromUrl(url) {
  url = /jsfiddle\.net\/(\w+\/?\d?)(\/embed\/?)?/.exec(url)

  return url ? url[1] : false
}

export function getEmbedCodeUrl(url) {
  if (url.indexOf('codepen.') > -1) {
    url = url.replace('/pen', '/embed') + '?height=' + HIT_MIN_HEIGHT + '&theme-id=28760&default-tab=result&embed-version=2'
  } else if (url.indexOf('jsfiddle.net') > -1) {
    url = '//jsfiddle.net/' + getJsFiddleIdFromUrl(url) + '/embedded/result,js,html,css/dark'
  }

  return url || ''
}

export default {}



// WEBPACK FOOTER //
// ./src/services/Utils/index.js